/* eslint-disable array-bracket-newline */
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AutoSizer } from 'react-virtualized';
import { IDexTrade, ITicker } from '@kattana-io/common';
import useCollectTickers from '../../../../components/DexTrades/useCollectTickers';
import { IStore } from '../../../../reducers';
import WalletTradesTable from './Table';
import WalletTradesTableMobile from './TableMobile';
import { switchCurrentTicker } from '../../../../Authlogic';

interface ITradesDataLayerProps {
  chain: string;
  trades: IDexTrade[];
  loading: boolean;
  isMobile?: boolean;
}

/**
 * Data-layer wrapper
 * @param param0
 * @returns
 */
const TradesDataLayer = ({
  chain,
  trades,
  loading,
  isMobile,
}: ITradesDataLayerProps) => {
  const timezone = useSelector((state: IStore) => state.timezone.current);

  const { tickers, loadingTickers } = useCollectTickers(trades);

  const onTickerClick = useCallback((ticker: ITicker) => {
    switchCurrentTicker(ticker);
  }, []);

  const collection = useMemo(() => {
    if (loading || loadingTickers) {
      return [];
    }
    const filteredTrades = trades.filter(({ chain, pair }) => {
      const key = `${chain}-${pair}`;
      const item = tickers[key];
      return !!item;
    });
    return filteredTrades;
  }, [loading, loadingTickers, trades, tickers]);

  return isMobile ? (
    <WalletTradesTableMobile
      network={chain}
      timezone={timezone}
      trades={collection}
      tickers={tickers}
      loading={loading || loadingTickers}
      onTickerClick={onTickerClick}
    />
  ) : (
    <AutoSizer style={{ width: '100%', height: '100%' }}>
      {({ width }) => (
        <WalletTradesTable
          network={chain}
          timezone={timezone}
          trades={collection}
          tickers={tickers}
          loading={loading || loadingTickers}
          width={width}
          onTickerClick={onTickerClick}
        />
      )}
    </AutoSizer>
  );
};

export default TradesDataLayer;
